module.exports = __webpack_public_path__ + "media/images/logo_t8-bdfe051b14a048aa46d31b3c009b41bf.svg";